
import constate from "constate";
import useSessionContext from "../hooks/useSessionContext";

const [SessionProvider, useSession] = constate(useSessionContext);

export { SessionProvider, useSession };
